import { memo } from 'react'
import { Skeleton } from '@wellesley/ui'
import { UsersPreview } from '@wellesley/user'
import pluralize from 'helpers/pluralize'
import UsersPreviewSkeleton from 'components/Skeletons/UsersPreviewSkeleton'
import { useGetApiV1EventsByEventIdMutualQuery } from '../../api'

const AVATAR_SIZE = 40
const MAX_AVATARS = 5
const MAX_NAMES = 2

type MutualAttendeesProps = {
  eventId: string
}

export const MutualAttendees = memo(({ eventId }: MutualAttendeesProps) => {
  const { isLoading, data } = useGetApiV1EventsByEventIdMutualQuery({
    eventId,
  })

  const mutualAttendees = data || []
  const visibleAttendees = mutualAttendees?.slice(0, MAX_AVATARS) || []
  const totalCount = mutualAttendees?.length || 0

  return (
    <div className="space-y-s">
      {isLoading ? (
        <>
          <div className="py-xxxs">
            <UsersPreviewSkeleton count={MAX_AVATARS} size={AVATAR_SIZE} />
          </div>
          <div>
            <Skeleton className="mb-xs h-5 w-1/2" />
            <Skeleton className="h-10 w-full" />
          </div>
        </>
      ) : (
        !!totalCount && (
          <>
            <UsersPreview users={visibleAttendees} avatarSize={AVATAR_SIZE} />
            <div>
              <span className="mb-xxxs block text-base font-semibold">
                {pluralize('mutual friend', totalCount, true)}
              </span>
              <span>
                <span>
                  {mutualAttendees
                    .slice(0, MAX_NAMES)
                    .map(({ displayName }) => displayName)
                    .join(', ')}
                  {totalCount > MAX_NAMES &&
                    ` and ${pluralize('other', totalCount - MAX_NAMES, true)}`}
                  &nbsp;interested in this event
                </span>
              </span>
            </div>
          </>
        )
      )}
    </div>
  )
})

MutualAttendees.displayName = 'MutualAttendees'
